
import _ from 'underscore'
import d3 from 'd3'
import Backbone from 'backbone'
import HitAreaLayerModel from '../models/HitAreaLayerModel'
import HitAreaLayerView from './HitAreaLayerView'
import LayerView from './LayerView'
import UnitLayerModel from '../models/UnitLayerModel'
import UnitLayerView from './UnitLayerView'

class LevelView extends Backbone.View {

  initialize(options) {
    this.d3el = d3.select(this.el)
    this.bindEvents()
  }

  bindEvents() {
    this.listenTo(this.model, 'change:opacity change:x change:y change:scale change:visible', this.renderAttributes)
    this.listenTo(this.model, 'change:transition', this.renderTransition)
  }

  unbindEvents() {
    this.stopListening()
  }

  clearTransition() {
    if (this.transition) {
      this.d3el.transition()
      this.transition = null
    }
  }

  renderTransition() {
    let {d3el, model} = this
    let t = model.get('transition')
    
    if (_.isEmpty(t.properties)) {
      return this.clearTransition()
    }

    this.transition = d3el
      .transition()
      .duration(t.duration)
      .ease(t.ease)

    let p = t.properties

    let x = _.has(p, 'x') ? p.x : model.get('x')
    let y = _.has(p, 'y') ? p.y : model.get('y')
    let scale = _.has(p, 'scale') ? p.scale : model.get('scale')
    let opacity = _.has(p, 'opacity') ? p.scale :model.get('opacity')

    this.transition
      .attr('transform', `translate(${x},${y}) scale(${scale})`)
      .style('opacity', opacity)

    model.set({x, y, scale, opacity}, {silent: true})
  }

  renderAttributes() {
    let {d3el, model} = this

    let origin = model.get('origin')
    let x = model.get('x')
    let y = model.get('y')
    let visible = model.get('visible')
    let opacity = model.get('opacity')
    let scale = model.get('scale')

    this.clearTransition()

    d3el
      .attr('transform', `translate(${x},${y}) scale(${scale})`)
      .style('display', visible ? null : 'none')
      .style('opacity', opacity)
  }

  render() {
    let {d3el, model} = this

    // Render each layer.
    
    let hitAreaLayer = null;

    model.get('layers').each(function (layer) {
      let layerView = null

      if (layer instanceof UnitLayerModel) {
        layerView = new UnitLayerView({
          model: layer,
          el: d3el.append('g').node()
        })
      } else if (layer instanceof HitAreaLayerModel) {
        hitAreaLayer = layer
        
      } else {
        layerView = new LayerView({
          model: layer,
          el: d3el.append('g').node()
        })
      }

      if (layerView) {
        layerView.render()
      }
    })

    // If a hit area layer is declared, it must be added last to ensure its
    // z-index is higher then all other layers.
    
    if (hitAreaLayer) {
      let layerView = new HitAreaLayerView({
          model: hitAreaLayer,
          el: d3el.append('g').node()
      })
      layerView.render()
    }

    // Capture origin bounds and update the model.

    let bounds = this.el.getBBox()

    model.set({
      origin: {
        x: bounds.x,
        y: bounds.y,
        width: bounds.width,
        height: bounds.height
      },
      scale: 1
    }, {silent: true})

    this.renderAttributes()

    return this
  }
}

export default LevelView
